// actionTypes.js
export const SET_VALUE_SOUSCRIPTION = "SET_VALUE_SOUSCRIPTION";
export const SET_CURRENT_PAGE_SOUSCRIPTION = "SET_CURRENT_PAGE_SOUSCRIPTION";
export const SET_ORDER_SOUSCRIPTION = "SET_ORDER_SOUSCRIPTION";
export const SET_SORT_FIELD_SOUSCRIPTION = "SET_SORT_FIELD_SOUSCRIPTION";
export const SET_PAGE_SIZE_SOUSCRIPTION = "SET_PAGE_SIZE_SOUSCRIPTION";
export const SET_CUSTOM_FILTERS_SOUSCRIPTION =
  "SET_CUSTOM_FILTERS_SOUSCRIPTION";
export const SET_SORTING_SOUSCRIPTION = "SET_SORTING_SOUSCRIPTION";
export const SET_ACTIVE_TAB_SOUSCRIPTION = "SET_ACTIVE_TAB_SOUSCRIPTION";
export const SET_QUERY_SOUSCRIPTION = "SET_QUERY_SOUSCRIPTION";
export const SET_ACTIF_SOUSCRIPTION = "SET_ACTIF_SOUSCRIPTION";
export const SET_SELECTED_OPTION_FILTERS_SOUSCRIPTION =
  "SET_SELECTED_OPTION_FILTERS_SOUSCRIPTION";
export const SET_SELECTED_OPTION_ID_SOUSCRIPTION =
  "SET_SELECTED_OPTION_ID_SOUSCRIPTION";
export const SET_COLUMN_SOUSCRIPTION = "SET_COLUMN_SOUSCRIPTION";
